import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {TogglerLink} from "./toggler_link"

export const togglerLinkLoader = function (options = {}) {
    componentLoader(componentConfig(TogglerLink, TogglerLink.config.componentTypeKey, TogglerLink.config.baseHtmlClass), options);
};

